import React, { Fragment, useEffect, useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  float: left;
  overflow: hidden;
`;

const ContainerLabel = styled.div`
  width: 100%;
  float: left;
`;

export default (props) => {
  let [isCollapsed, setCollapsed] = useState(props.isCollapsed);
  useEffect(() => {
    setCollapsed(props.isCollapsed);
  });
  return (
    <Fragment>
      <ContainerLabel onClick={() => setCollapsed(!isCollapsed)}>
        {props.label}
      </ContainerLabel>
      <Container style={{ height: isCollapsed ? 0 : "fit-content" }}>
        {props.content}
      </Container>
    </Fragment>
  );
};
